import { render } from "./memberRecord.vue?vue&type=template&id=479f1224&scoped=true"
import script from "./memberRecord.vue?vue&type=script&lang=js"
export * from "./memberRecord.vue?vue&type=script&lang=js"

import "./memberRecord.vue?vue&type=style&index=0&id=479f1224&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479f1224"]])

export default __exports__